import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({})
	.set('Add', new Immutable.Map({}))
	.set('Status', new Immutable.List([]))
	.set('Get', new Immutable.Map({}))
	.set('Search', new Immutable.List([]))

/* Types */
export const ACTION_GET_STATUS_DONATIVE = 'ACTION_GET_STATUS_DONATIVE'
export const ACTION_GET_DATA_DONATIVE = 'ACTION_GET_DATA_DONATIVE'
export const ACTION_SEARCH_DONATION = 'ACTION_SEARCH_DONATION'

/* Reducer */
export default (state = initialState, action) => {
	switch(action.type){
		case ACTION_GET_STATUS_DONATIVE:
			return state.set('Status', new Immutable.List(action.Obj))
		case ACTION_GET_DATA_DONATIVE:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_SEARCH_DONATION:
			return state.set('Search', new Immutable.List(action.Obj))
		default:
			return state
	}
}

/* Action Creators */

export const addStatusDonative = (form) => {
    
	let temp = {
		id: form.idApplicationStatus || null,
		descripcion: form.applicationDonation,
		deleted: form.newStatusApp,
		usuario: sessionStorage.uid
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: form.idApplicationStatus ? "api/updateStatusDonative" : "api/addStatusDonative",
			method: "POST",
			data: {...temp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getStatusDonative = () => {
	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: "api/getStatusDonative",
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid":sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_STATUS_DONATIVE , Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getDataApplicationDonation = (form) => {
	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service:  "api/getDataApplicationDonation",
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid":sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_DATA_DONATIVE , Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchApplicationDonation = (form) => {
    
	let temp = {
		id: parseInt(form.idApplicationStatus) || null,
		descripcion: form.appDonation || null,
		deleted: form.searchStatusApp || null
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: "api/searchApplicationDonation",
			method: "POST",
			data: {...temp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid":sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_STATUS_DONATIVE , Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearApplicationDonation = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_STATUS_DONATIVE, Obj: [] })
		dispatch({ type: ACTION_GET_DATA_DONATIVE, Obj: {} })
		return Promise.resolve()
	}
}



// WEBPACK FOOTER //
// ./src/modules/Configurations/DonationCheck/ApplicationStatus.js